import { io, Socket } from 'socket.io-client';

export class SocketSingleton {
	private static instance: SocketSingleton;
	private socket: Socket | Promise<Socket> | undefined;
	private constructor() {}
	public static getInstance(): SocketSingleton {
		if(!SocketSingleton.instance) {
			SocketSingleton.instance = new SocketSingleton();
		}
		return SocketSingleton.instance;
	}
	public isSocketConnected() {
		return this.socket && (this.socket as Socket).connected;
	}
	public getSocket(): Socket {
		if (this.isSocketConnected()) {
			return this.socket as Socket;
		} else {
			throw new Error('Socket not connected');
		}
	}
	public initializeSocket(url: string) {
		new Promise<Socket>((done) => {
			done(io(url, {
				reconnectionAttempts: 100,
				reconnectionDelay: 2000,
			}));
		}).then((socket) => {
			this.socket = socket;
			socket.on("connect_error", (err) => {
				console.log(`connect_error due to ${err.message}`);
			});
		})
	}
}